import { Checkbox } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from 'react-native';
import React, { Component } from 'react';
import '../../../../src/assets/styles/hrmw-mcd.scss';
import { ROUTES, HRMW_CONSTANTS } from '../../../constants';
import {LoadingCircle} from '../../../../src/components/common/loading';
import Text, { Large } from '@dbk/ui-text';
import Modal from '@dbk/ui-modal';

class HrmwForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            investmentInstructionChecked: false, 
            investmentAndTransferInstructionChecked: false,
            phonechecked: false,
            faxChecked: false,
            emailChecked: false,
            isInvalidData: true,
			showPaperlessConfirmationModal: false
         };
    }

	async componentWillReceiveProps(nextProps) {
		if(Array.isArray(nextProps.hrmw.saveFormStatus.proposals)) {
			if(this.props.paperless.isEdocumentFlow){
				this.setState({ showPaperlessConfirmationModal: true })
			}else{
				this.navigateToManageContact();
			}
		  }
	}

	componentWillUnmount(){
		if(!this.props.paperless.acceptAndProceed && this.props.hrmw.fromPaperless ){
			this.props.hrmw.setfromPaperless(false); 
		}
	}


	closeModal = () => {
		this.setState({ showPaperlessConfirmationModal: false });
		this.props.paperless.setAcceptAndProceed(false);
	}

	handleAcceptAndProceed = () => {
		this.props.paperless.setAcceptAndProceed(!this.props.paperless.acceptAndProceed);
	}

	navigateToManageContact = async () => {
		await this.props.hrmw.resetFormStatus();
		await this.props.hrmw.contactToBeAmend('');
		await this.props.hrmw.saveFilters('');
		this.props.changePage(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS_ROUTE);
	}

	// If triggered from Paperless flow show modal on accepting the HRMW form
	showPaperlessConfirmationModal = () => {
		const { i18n: { messages }, hrmw: { showSpinner, isValidData } } = this.props;
		return (
			<Modal
				isActive={true}
				onClose={this.closeModal}
				header={messages["app.edelivery.title"]}
				content={
					<div className="padding-20">
						<div className="text-indent">
							<Checkbox className="pad-right-10"
								onChange={() => this.handleAcceptAndProceed()} />
							<Large>{messages["app.profile.paperless.toReceivePaperlessStatements"]}</Large>
						</div>
						<div className="text-right margin-top-20">
						<Button disabled={!this.props.paperless.acceptAndProceed} 
						onPress={() => this.navigateToManageContact()}>
                			{messages["app.manageContactDetails.hrmwFormAcceptbutton"]} </Button>
						</div>
					</div>
				}
			/>)
	}

    render() {
        const { i18n: { messages }, hrmw: {showSpinner, isValidData} } = this.props;

		if(showSpinner) {
			return <LoadingCircle />
		}

		if(!isValidData) {
			return alert(messages['app.manageContactDetails.error.tryagain']);
		}

        return (
          <View className="layout">
            <div className="row small-12 medium-12 large-12">
			 <div className="row headerMargin ">
				<Text >{messages['app.manageContactDetails.hrmwForm']}</Text>
				</div>
              	<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						<b>{messages["app.manageContactDetails.hrmwFormFirstSubHeading"]}</b>
					</div>
					<div className="columns large-11 medium-11 small-11">
						<b>{messages["app.manageContactDetails.hrmwFormFirstSubHeadingText"]}</b>
					</div>
				</div>

                <div className="row headerMargin">
              		<div className="columns large-1 medium-1 small-1">
                		<b>{messages["app.manageContactDetails.hrmwFormFirstSubHeadingFirstContext"]}</b>
              		</div>
              		<div className="columns large-11 medium-11 small-11">
						<b>{messages["app.manageContactDetails.hrmwFormFirstSubHeadingFirstContextText"]}</b>
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						<b>{messages["app.manageContactDetails.hrmwFormFirstSubHeadingSecondContext"]}</b>
					</div>
					<div className="columns large-11 medium-11 small-11">
						<b>{messages["app.manageContactDetails.hrmwFormFirstSubHeadingSecondContextText"]}</b>
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						<b>{messages["app.manageContactDetails.hrmwFormFirstSubHeadingThirdContext"]}</b>
					</div>
					<div className="columns large-11 medium-11 small-11">
						<b>{messages["app.manageContactDetails.hrmwFormFirstSubHeadingThirdContextText"]}</b>
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormSecondSubHeading"]}
					</div>

					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormSecondSubHeadingText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormSecondSubHeadingFirstContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormSecondSubHeadingFirstContextText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeading"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeadingText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeadingFirstContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeadingFirstContextText"]}
					</div>
				</div>

				<div className="row headerMargin">        
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeadingSecondContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeadingSecondContextText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeadingThirdContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeadingThirdContextText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1"></div>
					<div className="columns large-11 medium-11 small-11">
						<div className="columns large-4 medium-4 small-4">
							{messages["app.manageContactDetails.hrmwFormInvestmentInstructions"]}
						</div>
						<div className="columns large-1 medium-1 small-1 leftAligned">
							<span>
								<Checkbox
									className='text-custom'
									id='investmentonly'
									testID='investment-instruction-checkbox'
									checked={this.state.investmentInstructionChecked}
									onChange={() => this.investmentInstructionClicked()}
								/>
							</span>
						</div>
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1"></div>
					<div className="columns large-11 medium-11 small-11">
						<div className="columns large-1 medium-1 small-1">
							{messages["app.manageContactDetails.hrmwForm.OR"]}
						</div>
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1"></div>
					<div className="columns large-11 medium-11 small-11">
						<div className="columns large-4 medium-4 small-4">
							{messages["app.manageContactDetails.hrmwFormTransferInstructions"]}
						</div>
						<div className="columns large-1 medium-1 small-1 leftAligned">
							<Checkbox
								className='text-custom' id='investmentAndTransferInstruction'
								testID='investment-transfer-instruction-checkbox'
								checked={this.state.investmentAndTransferInstructionChecked}
								onChange={() => this.investmentAndTransferInstructionClicked()}
							/>
						</div>
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1"></div>
					<div className="columns large-11 medium-11 small-11">
						<div className="columns large-3 medium-3 small-3">
							{messages["app.manageContactDetails.hrmwFormThirdSubHeadingThirdContextsubHeading"]}
						</div>
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1"></div>
					<div className="columns large-11 medium-11 small-11">
						<div className="columns large-4 medium-4 small-4">
							{messages["app.manageContactDetails.filter.phone"]}
						</div>
						<div className="columns large-1 medium-1 small-1 leftAligned">
							<Checkbox 
								className='text-custom'
								testID='phone-checkbox'
								checked={this.state.phoneChecked}
								onChange={() => this.phoneClicked()}
							/>
						</div>
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1"></div>
					<div className="columns large-11 medium-11 small-11">
						<div className="columns large-4 medium-4 small-4">
							{messages["app.manageContactDetails.addContact.fax"]}
						</div>
						<div className="columns large-1 medium-1 small-1 leftAligned">
							<Checkbox
								className='text-custom'
								testID='fax-checkbox'
								checked={this.state.faxChecked}
								onChange={() => this.faxClicked()}
							/>
						</div>
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1"></div>
					<div className="columns large-11 medium-11 small-11">
						<div className="columns large-4 medium-4 small-4">
							{messages["app.manageContactDetails.filter.email"]}
						</div>
						<div className="columns large-1 medium-1 small-1 leftAligned">
							<Checkbox
								className='text-custom'
								testID='email-checkbox'
								checked={this.state.emailChecked}
								onChange={() => this.emailClicked()}
							/>
						</div>
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeadingFourthContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeadingFourthContextText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeadingFifthContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeadingFifthContextText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeadingSixthContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormThirdSubHeadingSixthContextText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeading"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFirstContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFirstContextText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFirstContextFirstSubheading"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFirstContextFirstSubheadingText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFirstContextSecondSubheading"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFirstContextSecondSubheadingText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFirstContextThirdSubheading"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFirstContextThirdSubheadingText"]}
					</div>
				</div>
				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFirstContextFourthSubheading"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFirstContextFourthSubheadingText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFirstContextFifthSubheading"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFirstContextFifthSubheadingText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingSecondContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingSecondContextText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingThirdContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingThirdContextText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFourthContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFourthContextText"]}
					</div>
				</div>
				
				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFifthContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingFifthContextText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingSixthContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingSixthContextText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-1 medium-1 small-1">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingSeventhContext"]}
					</div>
					<div className="columns large-11 medium-11 small-11">
						{messages["app.manageContactDetails.hrmwFormFourthSubHeadingSeventhContextText"]}
					</div>
				</div>

				<div className="row headerMargin">
					<div className="columns large-12 medium-12 small-12">
						{messages["app.manageContactDetails.hrmwFormTerms&Condition"]}
					</div>
				</div>
            
            </div>
            
            <div className="row large-4 medium-4 small-4 acceptProceedDiv" >
                <Button size='large' disabled={this.state.isInvalidData} onClick={()=>this.proceed()} className="acceptbtnwidth" testID='accept-proceed-button'>
                    {messages["app.manageContactDetails.hrmwFormAcceptbutton"]} 
                </Button>
            </div>
			{ this.state.showPaperlessConfirmationModal && this.showPaperlessConfirmationModal()}
          </View>
        )
    }
  
    investmentInstructionClicked = () => {
		if(!this.state.investmentInstructionChecked) {
			this.setState({investmentAndTransferInstructionChecked: false}, () => {
				this.setState({investmentInstructionChecked: true}, () => {
					this.checkValidation();
				});
			});
		} else if(this.state.investmentInstructionChecked) {
			this.setState({
				investmentInstructionChecked: false,
				investmentAndTransferInstructionChecked: true
			}, () => {
				this.checkValidation();
			});
		}
    }

    investmentAndTransferInstructionClicked = () => {
		if(!this.state.investmentAndTransferInstructionChecked) {
			this.setState({investmentInstructionChecked: false}, () => {
				this.setState({investmentAndTransferInstructionChecked: true}, () => {
					this.checkValidation();
				});
			});
		} else if(this.state.investmentAndTransferInstructionChecked) {
			this.setState({
				investmentAndTransferInstructionChecked: false,
				investmentInstructionChecked: true
			}, () => {
				this.checkValidation();
			});
		}
    }

    phoneClicked = () => {
      this.setState({phonechecked: !this.state.phonechecked}, () => {
		this.checkValidation();
	  });
    }

    faxClicked = () => {
    	this.setState({faxChecked: !this.state.faxChecked}, () => {
			this.checkValidation();
		});
    }

    emailClicked = () => {
        this.setState({emailChecked: !this.state.emailChecked}, () => {
			this.checkValidation();
		});
    }

    checkValidation = () => {
      const { investmentInstructionChecked, investmentAndTransferInstructionChecked, faxChecked, emailChecked, phonechecked} = this.state;
      if((investmentInstructionChecked || investmentAndTransferInstructionChecked)  && (faxChecked || emailChecked || phonechecked)){
        this.setState({isInvalidData: false});
      } else {
        this.setState({isInvalidData: true});
      }
    }

    proceed = async() => {
      const { investmentInstructionChecked, investmentAndTransferInstructionChecked, faxChecked, emailChecked, phonechecked} = this.state;
      const reqOptions = [];
      if(investmentInstructionChecked) {
        reqOptions.push({option: HRMW_CONSTANTS.INVESTMENT, value: 'Y'});
      }
      if(investmentAndTransferInstructionChecked) {
        reqOptions.push({option: HRMW_CONSTANTS.INVESTMENT_TRANSFER, value: 'Y'});
      }
      if(faxChecked) {
        reqOptions.push({option: HRMW_CONSTANTS.FAX, value: 'Y'});
      }
      if(emailChecked) {
        reqOptions.push({option: HRMW_CONSTANTS.EMAIL, value: 'Y'});
      }
      if(phonechecked) {
        reqOptions.push({option: HRMW_CONSTANTS.PHONE, value: 'Y'});
      }

		await this.props.hrmw.saveForm(reqOptions);

    }
}

export default createContainer({
    $queries: {
      i18n: {
        messages: true,
      },
      hrmw: {
        saveForm: {$call: 'saveForm'},
		resetFormStatus: {$call: 'resetFormStatus'},
		contactToBeAmend: { $call: 'setAmendContactDetail' },
		setfromPaperless: { $call: 'setfromPaperless' },
		saveFilters: { $call: 'saveFilters'},
		fromPaperless: true,
		saveFormStatus: true,
		showSpinner: true,
		isValidData: true
      },
	  paperless: {
		isEdocumentFlow: true,
		acceptAndProceed: true,
		setAcceptAndProceed: { $set: 'acceptAndProceed' },
	  }
    },
  })(HrmwForm);